/* ============================================================
   Clara & Co. — Shopify Theme JavaScript — v3
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ============================================================
  // POPUP — shows after 10 seconds, once per session
  // ============================================================
  var popup = document.getElementById('offer-popup');
  var popupClose = document.getElementById('popup-close');
  var popupDismiss = document.getElementById('popup-dismiss');

  if (popup && !sessionStorage.getItem('popupDismissed')) {
    setTimeout(function () {
      popup.classList.add('show');
    }, 10000);
  }

  function closePopup() {
    if (popup) {
      popup.classList.remove('show');
      sessionStorage.setItem('popupDismissed', '1');
    }
  }

  if (popupClose) popupClose.addEventListener('click', closePopup);
  if (popupDismiss) popupDismiss.addEventListener('click', closePopup);
  if (popup) {
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });
  }

  // ============================================================
  // FAQ ACCORDION
  // ============================================================
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ============================================================
  // FOOTER ACCORDION
  // ============================================================
  document.querySelectorAll('.footer-accordion-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.footer-accordion-item');
      item.classList.toggle('open');
    });
  });

  // ============================================================
  // REVIEWS SLIDER — scroll dots sync
  // ============================================================
  var slider = document.getElementById('reviews-slider');
  var dots = document.querySelectorAll('.reviews-dot');

  if (slider && dots.length) {
    // Dot click → scroll to card
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(this.dataset.index);
        var cards = slider.querySelectorAll('.review-card');
        if (cards[index]) {
          slider.scrollTo({ left: cards[index].offsetLeft - 20, behavior: 'smooth' });
        }
      });
    });

    // Scroll → update active dot
    slider.addEventListener('scroll', function () {
      var cards = slider.querySelectorAll('.review-card');
      var sliderLeft = slider.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - sliderLeft - 20);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      dots.forEach(function (d) { d.classList.remove('active'); });
      if (dots[closest]) dots[closest].classList.add('active');
    }, { passive: true });
  }

  // ============================================================
  // ACTIVE NAV LINK
  // ============================================================
  var currentPath = window.location.pathname;
  document.querySelectorAll('.collections-nav-inner a').forEach(function (link) {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

  // ============================================================
  // HAMBURGER MENU — mobile drawer
  // ============================================================
  var hamburgerBtn = document.getElementById('hamburger-btn');
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  var mobileMenuClose = document.getElementById('mobile-menu-close');

  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add('open');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.add('open');
    if (hamburgerBtn) hamburgerBtn.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove('open');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.remove('open');
    if (hamburgerBtn) hamburgerBtn.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (hamburgerBtn) hamburgerBtn.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
  if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', closeMobileMenu);

  // ============================================================
  // SHOP ALL SUBMENU — expandable collections
  // ============================================================
  var shopAllArrow = document.querySelector('.mobile-submenu-arrow');
  var shopAllSubmenu = document.getElementById('shop-all-submenu');

  if (shopAllArrow && shopAllSubmenu) {
    shopAllArrow.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = shopAllSubmenu.classList.contains('open');
      shopAllSubmenu.classList.toggle('open');
      shopAllArrow.classList.toggle('open');
    });
  }

  // ============================================================
  // SOCIAL LOVE SWIPER — dots sync
  // ============================================================
  var socialSwiper = document.getElementById('social-love-swiper');
  var socialDots = document.querySelectorAll('.social-dot');

  if (socialSwiper && socialDots.length) {
    socialDots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var idx = parseInt(this.dataset.index);
        var slides = socialSwiper.querySelectorAll('.social-love-slide');
        if (slides[idx]) {
          socialSwiper.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
        }
      });
    });
    socialSwiper.addEventListener('scroll', function() {
      var slides = socialSwiper.querySelectorAll('.social-love-slide');
      var sw = socialSwiper.offsetWidth;
      var closest = Math.round(socialSwiper.scrollLeft / sw);
      socialDots.forEach(function(d) { d.classList.remove('active'); });
      if (socialDots[closest]) socialDots[closest].classList.add('active');
    }, { passive: true });
  }

  // ============================================================
  // ANNOUNCEMENT BAR — pause marquee on hover
  // ============================================================
  var track = document.querySelector('.announcement-track');
  if (track) {
    track.addEventListener('mouseenter', function () {
      this.style.animationPlayState = 'paused';
    });
    track.addEventListener('mouseleave', function () {
      this.style.animationPlayState = 'running';
    });
  }

});
